export const privacyContent = `# POLITICA DE PRIVACIDAD

## PricingIntelligence

---

> **AVISO IMPORTANTE:** Este documento es un modelo referencial y requiere revision obligatoria por un abogado habilitado en el Estado Plurinacional de Bolivia antes de su publicación o uso. No constituye asesoramiento juridico. Los placeholders indicados entre corchetes [ASI] deben ser completados con la información correspondiente antes de su entrada en vigencia.

---

**Responsable del Tratamiento:** [NOMBRE DE LA EMPRESA]
**NIT:** [NIT]
**Domicilio Legal:** [DIRECCION], [CIUDAD], Estado Plurinacional de Bolivia
**Correo de Proteccion de Datos:** [EMAIL_PROTECCION_DATOS]
**Sitio Web:** [URL_SITIO_WEB]

**Fecha de entrada en vigencia:** [FECHA_VIGENCIA]
**Ultima actualizacion:** [FECHA_ACTUALIZACION]

---

## INDICE

1. [Introduccion y Alcance](#1-introduccion-y-alcance)
2. [Marco Legal Aplicable](#2-marco-legal-aplicable)
3. [Datos Personales que Recopilamos](#3-datos-personales-que-recopilamos)
4. [Como Utilizamos los Datos](#4-como-utilizamos-los-datos)
5. [Base Legal del Tratamiento](#5-base-legal-del-tratamiento)
6. [Comparticion de Datos con Terceros](#6-comparticion-de-datos-con-terceros)
7. [Transferencias Internacionales de Datos](#7-transferencias-internacionales-de-datos)
8. [Tratamiento de Datos por el Asistente de Inteligencia Artificial](#8-tratamiento-de-datos-por-el-asistente-de-inteligencia-artificial)
9. [Monitoreo de Precios y Datos Publicos](#9-monitoreo-de-precios-y-datos-publicos)
10. [Retencion de Datos](#10-retencion-de-datos)
11. [Seguridad de los Datos](#11-seguridad-de-los-datos)
12. [Derechos del Usuario](#12-derechos-del-usuario)
13. [Cookies y Tecnologias Similares](#13-cookies-y-tecnologias-similares)
14. [Menores de Edad](#14-menores-de-edad)
15. [Cambios a la Politica de Privacidad](#15-cambios-a-la-politica-de-privacidad)
16. [Contacto](#16-contacto)

---

## 1. INTRODUCCION Y ALCANCE

**1.1.** La presente Politica de Privacidad (en adelante, la "Politica") describe como [NOMBRE DE LA EMPRESA] (en adelante, el "Responsable" o "nosotros") recopila, utiliza, almacena, protege y comparte los datos personales de los usuarios (en adelante, los "Usuarios" o "usted") de la plataforma PricingIntelligence (en adelante, la "Plataforma").

**1.2.** Esta Politica se aplica a todos los datos personales tratados a traves de:

   a) El sitio web [URL_SITIO_WEB];

   b) La plataforma web de PricingIntelligence;

   c) Las interfaces de programacion de aplicaciones (APIs) de la Plataforma;

   d) Las comunicaciones electronicas entre el Responsable y los Usuarios.

**1.3.** Al acceder y utilizar la Plataforma, usted acepta las practicas de tratamiento de datos descritas en la presente Politica. Si no esta de acuerdo con alguna de estas practicas, le solicitamos abstenerse de utilizar la Plataforma.

**1.4.** Esta Politica complementa y forma parte integrante de los Terminos y Condiciones de Uso de PricingIntelligence.

---

## 2. MARCO LEGAL APLICABLE

**2.1.** El tratamiento de datos personales realizado por el Responsable se rige por la siguiente normativa del Estado Plurinacional de Bolivia:

   a) **Constitucion Politica del Estado (CPE):**
      - Articulo 21, numeral 2: Derecho a la privacidad, intimidad, honra, imagen y dignidad;
      - Articulo 25: Inviolabilidad de las comunicaciones privadas;
      - Articulo 130: Accion de Proteccion de Privacidad;

   b) **Ley 164 (Ley General de Telecomunicaciones, Tecnologias de Informacion y Comunicacion y Servicio Postal):**
      - Articulos 56 al 60: Proteccion de datos en el ambito de las telecomunicaciones y TIC;
      - Articulo 59: Obligacion de los operadores de garantizar la proteccion de datos personales;

   c) **Decreto Supremo 1793 (Reglamento para el Desarrollo de Tecnologias de Informacion y Comunicacion):** Disposiciones sobre proteccion de datos en el contexto del desarrollo tecnologico;

   d) **Codigo Civil (Decreto Ley 12760):** Disposiciones generales sobre derecho a la intimidad y proteccion de la personalidad;

   e) **Codigo Penal (Ley 1768):** Articulos 363 bis y ter sobre manipulacion y alteracion informatica.

**2.2.** Sin perjuicio de que Bolivia no cuenta actualmente con una ley integral de proteccion de datos personales equivalente al Reglamento General de Proteccion de Datos (RGPD) de la Union Europea, el Responsable adopta voluntariamente principios y practicas alineados con estandares internacionales de proteccion de datos, en beneficio de los Usuarios.

---

## 3. DATOS PERSONALES QUE RECOPILAMOS

**3.1. Datos de Registro y Perfil.** Cuando usted se registra en la Plataforma, recopilamos:

   - Nombre completo;
   - Direccion de correo electronico;
   - Nombre de la empresa u organizacion;
   - Numero de Identificacion Tributaria (NIT) — proporcionado de forma voluntaria;
   - Pais de residencia;
   - Segmento de industria;
   - Tamano de la empresa;
   - Telefono de contacto — proporcionado de forma voluntaria;
   - Contrasena (almacenada en formato cifrado e irreversible).

**3.2. Datos Comerciales y de Negocio.** Durante el uso de la Plataforma, usted puede ingresar datos relacionados con su actividad comercial, incluyendo:

   - Catalogos de materiales y productos;
   - Precios, costos y margenes;
   - Modelos de calculo y variables de pricing;
   - Cotizaciones y sus detalles;
   - Informacion sobre clientes y proveedores;
   - Datos de flujos de aprobación.

   **Nota:** Estos datos comerciales son propiedad del Tenant y se tratan conforme a lo establecido en los Terminos y Condiciones de Uso. Su tratamiento se limita estrictamente a la prestacion del Servicio.

**3.3. Datos de Interaccion con el Asistente de IA.** Cuando usted utiliza el Asistente de IA, recopilamos:

   - Texto de las consultas realizadas;
   - Respuestas generadas por el Asistente;
   - Fecha, hora y duracion de cada interaccion;
   - Contexto de datos de la Plataforma utilizado para generar las respuestas.

   Se detalla el tratamiento de estos datos en la sección 8 de la presente Politica.

**3.4. Datos Tecnicos y de Uso.** De forma automatica, la Plataforma recopila:

   - Direccion de protocolo de internet (IP);
   - Tipo y version de navegador web;
   - Sistema operativo;
   - Paginas visitadas dentro de la Plataforma y tiempo de permanencia;
   - Acciones realizadas (logs de actividad);
   - Fecha y hora de acceso;
   - Identificadores de sesion (cookies esenciales).

**3.5. Datos de Facturacion.** Cuando corresponda, recopilamos:

   - Razon social del Tenant;
   - NIT del Tenant;
   - Domicilio fiscal;
   - Historial de pagos y facturación.

   **Nota:** El Responsable no almacena datos de tarjetas de credito o debito. Los pagos con tarjeta son procesados por proveedores de pago certificados conforme a estandares PCI-DSS.

---

## 4. COMO UTILIZAMOS LOS DATOS

**4.1.** Utilizamos los datos personales recopilados para las siguientes finalidades:

   a) **Prestacion del Servicio:** Crear y gestionar cuentas de usuario, proporcionar acceso a la Plataforma y sus funcionalidades, procesar y almacenar datos comerciales, generar cotizaciones y reportes;

   b) **Funcionamiento del Asistente de IA:** Procesar consultas del Usuario y generar respuestas contextualizadas utilizando el modelo de lenguaje del Proveedor de IA;

   c) **Mejora del Servicio:** Analizar patrones de uso anonimizados para mejorar la experiencia del usuario, corregir errores y desarrollar nuevas funcionalidades;

   d) **Comunicaciones del Servicio:** Enviar notificaciones relacionadas con la cuenta del Usuario, alertas de seguridad, actualizaciones del Servicio y comunicaciones contractuales;

   e) **Soporte Tecnico:** Resolver consultas, incidencias y solicitudes de soporte;

   f) **Seguridad:** Detectar, prevenir y responder a incidentes de seguridad, fraude o actividades sospechosas;

   g) **Cumplimiento Legal:** Cumplir con obligaciones legales, tributarias y regulatorias, incluyendo la emision de notas fiscales conforme a la normativa del SIN;

   h) **Facturacion y Cobro:** Gestionar la facturacion, cobro y administracion de suscripciones.

**4.2. Compromisos respecto al uso de datos:**

   a) **NO vendemos datos personales ni datos comerciales de nuestros Usuarios a terceros**, bajo ninguna circunstancia;

   b) **NO utilizamos los datos comerciales de los Usuarios para entrenar modelos de inteligencia artificial**, propios ni de terceros;

   c) **NO enviamos comunicaciones comerciales no solicitadas** (spam) ni compartimos datos con terceros para fines de marketing;

   d) **NO realizamos perfilamiento automatizado** con efectos legales o significativos sin consentimiento expreso del Usuario.

---

## 5. BASE LEGAL DEL TRATAMIENTO

**5.1.** El tratamiento de datos personales se fundamenta en las siguientes bases legales:

   a) **Ejecucion del contrato:** El tratamiento es necesario para la ejecucion del contrato de servicio entre el Responsable y el Usuario (Terminos y Condiciones de Uso y/o Contrato de Licencia SaaS). Aplica a las finalidades descritas en los incisos a), d), e) y h) de la seccion 4.1;

   b) **Consentimiento:** El Usuario otorga su consentimiento al registrarse en la Plataforma y al utilizar funcionalidades especificas como el Asistente de IA. Aplica a las finalidades descritas en los incisos b) y c) de la seccion 4.1. El consentimiento puede ser revocado en cualquier momento conforme a la seccion 12;

   c) **Interes legitimo:** El Responsable tiene un interes legitimo en garantizar la seguridad de la Plataforma, prevenir fraudes y mejorar sus servicios. Aplica a la finalidad descrita en el inciso f) de la seccion 4.1;

   d) **Obligacion legal:** El tratamiento es necesario para cumplir con obligaciones legales y tributarias vigentes en Bolivia. Aplica a la finalidad descrita en el inciso g) de la seccion 4.1.

---

## 6. COMPARTICION DE DATOS CON TERCEROS

**6.1.** El Responsable podra compartir datos personales unicamente con las siguientes categorias de terceros, y unicamente en la medida estrictamente necesaria para las finalidades indicadas:

   a) **Proveedor de Inteligencia Artificial (Anthropic, Inc.):** Las consultas realizadas al Asistente de IA son procesadas por Anthropic, Inc., empresa con sede en San Francisco, California, Estados Unidos de America. Solo se comparten los datos contenidos en las consultas del Usuario y el contexto necesario para generar respuestas. Vease la seccion 8 para mayor detalle;

   b) **Proveedores de Infraestructura (Hosting):** Los datos se almacenan en servidores proporcionados por [PROVEEDOR_HOSTING], ubicados en [UBICACION_SERVIDORES]. Estos proveedores actuan como encargados del tratamiento bajo acuerdos contractuales que garantizan la seguridad y confidencialidad de los datos;

   c) **Proveedores de Pago:** Los pagos son procesados por [PROVEEDOR_PAGO], quien recibe unicamente los datos necesarios para procesar la transaccion. No compartimos datos comerciales ni de uso de la Plataforma con proveedores de pago;

   d) **Asesores Profesionales:** Podremos compartir datos con nuestros asesores legales, contables y auditores, sujetos a obligaciones de confidencialidad profesional;

   e) **Autoridades Bolivianas:** Compartiremos datos personales con autoridades gubernamentales, judiciales o administrativas bolivianas unicamente ante requerimiento formal y legalmente vinculante, conforme a la legislacion vigente.

**6.2.** En ningun caso compartiremos Datos del Cliente con competidores del Usuario ni con terceros para fines de marketing, publicidad o elaboracion de perfiles comerciales.

**6.3.** Todos los terceros con quienes compartimos datos personales estan sujetos a obligaciones contractuales de confidencialidad y seguridad.

---

## 7. TRANSFERENCIAS INTERNACIONALES DE DATOS

**7.1.** En el curso de la prestacion del Servicio, ciertos datos personales podran ser transferidos fuera del territorio del Estado Plurinacional de Bolivia, especificamente:

   a) **A Anthropic, Inc. (Estados Unidos):** Las consultas realizadas al Asistente de IA y el contexto necesario son transferidos a servidores de Anthropic, Inc. en Estados Unidos para su procesamiento. Vease la seccion 8 para mayor detalle;

   b) **A proveedores de infraestructura (cloud hosting):** Los datos almacenados en la Plataforma pueden estar alojados en centros de datos ubicados en [PAIS_SERVIDORES], operados por [PROVEEDOR_HOSTING].

**7.2.** Si bien Bolivia no cuenta con un regimen especifico de transferencias internacionales de datos comparable al de otras jurisdicciones, el Responsable adopta las siguientes medidas para garantizar la proteccion de los datos transferidos:

   a) Suscripcion de acuerdos de procesamiento de datos con todos los proveedores internacionales;

   b) Verificacion de que los proveedores cumplan con estandares de seguridad reconocidos internacionalmente (SOC 2, ISO 27001 u otros equivalentes);

   c) Cifrado de los datos en transito y en reposo;

   d) Minimizacion de los datos transferidos a lo estrictamente necesario para la finalidad correspondiente.

**7.3.** Al utilizar la Plataforma y, en particular, el Asistente de IA, el Usuario consiente expresamente la transferencia internacional de sus datos conforme a lo descrito en la presente seccion.

---

## 8. TRATAMIENTO DE DATOS POR EL ASISTENTE DE INTELIGENCIA ARTIFICIAL

**8.1. Funcionamiento.** El Asistente de IA utiliza la API de modelos de lenguaje de Anthropic, Inc. para procesar consultas del Usuario y generar respuestas. El flujo de datos es el siguiente:

   a) El Usuario formula una consulta a traves de la interfaz del Asistente de IA;

   b) La Plataforma compone un contexto que puede incluir datos del Tenant relevantes para la consulta (como datos de modelos de precios, cotizaciones o materiales);

   c) La consulta y el contexto son enviados a la API de Anthropic mediante una conexion cifrada (TLS 1.3);

   d) Anthropic procesa la consulta y devuelve una respuesta;

   e) La respuesta es presentada al Usuario a traves de la Plataforma.

**8.2. Datos procesados por el Asistente de IA.** Los datos que pueden ser incluidos en las consultas al Asistente de IA comprenden:

   a) El texto de la consulta formulada por el Usuario;

   b) Datos contextuales del Tenant: nombres de productos, precios, costos, descripciones de materiales, modelos de pricing, datos de cotizaciones y otra informacion comercial necesaria para generar respuestas relevantes;

   c) Metadatos de la sesion: idioma, rol del usuario, nombre del Tenant.

**8.3. Garantias respecto al tratamiento por Anthropic:**

   a) Las consultas enviadas a Anthropic a traves de la API **NO son utilizadas por Anthropic para entrenar sus modelos de lenguaje**, conforme a la politica de uso de la API de Anthropic vigente a la fecha de publicacion de la presente Politica;

   b) Anthropic puede retener temporalmente los datos de las consultas para fines de deteccion de abuso y seguridad, conforme a su propia politica de privacidad;

   c) El Responsable no tiene control sobre las practicas de retencion de datos de Anthropic mas alla de lo establecido en los acuerdos contractuales suscritos.

**8.4. Recomendaciones al Usuario:**

   a) Evite incluir datos personales sensibles (datos de salud, financieros personales, numeros de documento de identidad) en las consultas al Asistente de IA;

   b) Tenga presente que las respuestas del Asistente de IA son generadas automaticamente y pueden contener inexactitudes;

   c) Si desea desactivar el Asistente de IA, contacte al Administrador de su Tenant o al soporte tecnico del Responsable.

**8.5. Historial de conversaciones.** Las conversaciones con el Asistente de IA se almacenan en la Plataforma para su consulta posterior por el Usuario. El historial puede ser eliminado por el Usuario en cualquier momento. La eliminacion en la Plataforma no implica la eliminacion inmediata de los registros temporales que Anthropic pudiera mantener conforme a su politica.

---

## 9. MONITOREO DE PRECIOS Y DATOS PUBLICOS

**9.1.** La Plataforma ofrece funcionalidades de monitoreo automatizado de precios que recopilan informacion publicada en fuentes de acceso publico en internet.

**9.2. Naturaleza de los datos recopilados:**

   a) Los datos recopilados mediante el monitoreo de precios son datos publicados abiertamente en sitios web de comercio electronico, marketplaces y catalogos en linea;

   b) NO se recopilan datos personales de consumidores, visitantes ni usuarios de los sitios web monitoreados;

   c) La informacion recopilada se limita a: nombres de productos, precios, descripciones, categorias y datos similares de caracter comercial publico.

**9.3.** Los datos recopilados mediante el monitoreo son almacenados dentro del entorno del Tenant que configuro el monitoreo y estan sujetos a las mismas medidas de seguridad y aislamiento que los demas Datos del Cliente.

**9.4.** El Responsable no garantiza la exactitud ni la vigencia de los datos recopilados de fuentes externas. El Usuario es el unico responsable de verificar la informacion y de asegurar que su uso cumpla con la normativa aplicable.

---

## 10. RETENCION DE DATOS

**10.1.** El Responsable retendra los datos personales unicamente durante el tiempo necesario para cumplir con las finalidades para las que fueron recopilados, conforme a los siguientes criterios:

   | Categoria de Datos | Periodo de Retencion |
   |---|---|
   | Datos de registro y perfil | Durante la vigencia de la suscripcion + 30 dias post-cancelacion |
   | Datos comerciales del Tenant | Durante la vigencia de la suscripcion + 30 dias para exportacion |
   | Historial de conversaciones con IA | Durante la vigencia de la suscripcion (eliminable por el Usuario en cualquier momento) |
   | Datos tecnicos y logs de actividad | Doce (12) meses desde su generacion |
   | Datos de facturacion y registros fiscales | Hasta ocho (8) anos conforme a la Ley 843 y normativa tributaria vigente |
   | Copias de seguridad | Noventa (90) dias despues de la eliminacion de los datos de produccion |
   | Registros de seguridad (incidentes) | Tres (3) anos desde el cierre del incidente |

**10.2.** Transcurridos los periodos de retencion indicados, los datos seran eliminados de forma segura e irreversible de los sistemas del Responsable, salvo que exista una obligacion legal de conservarlos por un periodo mayor.

---

## 11. SEGURIDAD DE LOS DATOS

**11.1.** El Responsable implementa medidas tecnicas y organizativas apropiadas para proteger los datos personales contra el acceso no autorizado, la perdida, la alteracion, la divulgacion o la destruccion, incluyendo:

   a) **Cifrado en transito:** Todas las comunicaciones entre el Usuario y la Plataforma se cifran mediante protocolo TLS 1.3 (Transport Layer Security);

   b) **Cifrado en reposo:** Los datos almacenados se cifran mediante algoritmo AES-256;

   c) **Autenticacion segura:** Sistema de autenticacion basado en JSON Web Tokens (JWT) con tokens de refresco y expiracion configurable;

   d) **Aislamiento de datos:** Separacion logica estricta de los datos de cada Tenant, impidiendo el acceso cruzado entre organizaciones;

   e) **Control de acceso basado en roles:** Sistema de permisos con cuatro niveles de acceso (Administrador de Plataforma, Administrador de Empresa, Vendedor, Aprobador);

   f) **Copias de seguridad:** Respaldos automatizados diarios de las bases de datos, almacenados de forma cifrada;

   g) **Monitoreo de seguridad:** Sistemas de deteccion de accesos no autorizados y actividades anomalas;

   h) **Gestion de vulnerabilidades:** Actualizacion periodica de componentes de software y dependencias.

**11.2.** En caso de producirse una brecha de seguridad que afecte datos personales, el Responsable se compromete a:

   a) Notificar a los Tenants afectados dentro de las setenta y dos (72) horas siguientes a la deteccion de la brecha;

   b) Informar sobre la naturaleza de la brecha, los datos afectados, las medidas adoptadas y las recomendaciones para los Usuarios;

   c) Adoptar las medidas necesarias para mitigar los efectos de la brecha y prevenir su recurrencia;

   d) Documentar el incidente y las acciones correctivas implementadas;

   e) Reportar el incidente a las autoridades competentes cuando la legislacion asi lo requiera.

---

## 12. DERECHOS DEL USUARIO

**12.1.** De conformidad con la normativa boliviana vigente, y en particular con el derecho a la privacidad consagrado en el articulo 21, numeral 2, de la Constitucion Politica del Estado, usted tiene los siguientes derechos respecto a sus datos personales:

   a) **Derecho de Acceso:** Solicitar informacion sobre los datos personales que el Responsable mantiene sobre usted y el tratamiento que se les da;

   b) **Derecho de Rectificacion:** Solicitar la correccion de datos personales inexactos o incompletos;

   c) **Derecho de Eliminacion:** Solicitar la eliminacion de sus datos personales cuando estos ya no sean necesarios para la finalidad para la que fueron recopilados, sujeto a las obligaciones legales de retencion;

   d) **Derecho de Portabilidad:** Solicitar la exportacion de sus Datos del Cliente en formatos estandar y legibles por maquina (CSV, JSON, PDF);

   e) **Derecho de Oposicion:** Oponerse al tratamiento de sus datos personales para finalidades no esenciales para la prestacion del Servicio;

   f) **Derecho de Revocacion del Consentimiento:** Revocar en cualquier momento el consentimiento otorgado para el tratamiento de sus datos, sin que ello afecte la licitud del tratamiento realizado con anterioridad.

**12.2.** Para ejercer cualquiera de estos derechos, el Usuario debera enviar una solicitud por escrito a [EMAIL_PROTECCION_DATOS], indicando:

   a) Nombre completo y correo electronico registrado;
   b) Derecho que desea ejercer;
   c) Descripcion detallada de su solicitud;
   d) Copia de un documento de identidad vigente para verificacion.

**12.3.** El Responsable atendera las solicitudes en un plazo maximo de quince (15) dias habiles a partir de la recepcion de la solicitud completa. En caso de que la complejidad o el volumen de la solicitud lo requiera, este plazo podra extenderse por quince (15) dias habiles adicionales, previa notificacion al solicitante.

**12.4.** Si el Usuario considera que sus derechos han sido vulnerados, podra interponer la Accion de Proteccion de Privacidad prevista en el articulo 130 de la Constitucion Politica del Estado ante la autoridad judicial competente.

---

## 13. COOKIES Y TECNOLOGIAS SIMILARES

**13.1.** La Plataforma utiliza unicamente cookies esenciales estrictamente necesarias para su funcionamiento, las cuales incluyen:

   | Cookie | Finalidad | Duracion |
   |---|---|---|
   | Token de sesion (JWT) | Autenticacion y mantenimiento de la sesion del Usuario | Hasta la expiracion del token o cierre de sesion |
   | Preferencias de interfaz | Recordar preferencias de visualizacion del Usuario | Persistente hasta eliminacion manual |

**13.2.** La Plataforma **NO utiliza:**

   a) Cookies de seguimiento (tracking) de terceros;
   b) Cookies publicitarias;
   c) Cookies de redes sociales;
   d) Pixeles de seguimiento;
   e) Tecnologias de fingerprinting del navegador.

**13.3.** Al tratarse exclusivamente de cookies esenciales para el funcionamiento del Servicio, no se requiere consentimiento previo del Usuario para su instalacion.

**13.4.** El Usuario puede configurar su navegador para rechazar cookies, con la advertencia de que esta configuracion puede afectar el funcionamiento de la Plataforma.

---

## 14. MENORES DE EDAD

**14.1.** La Plataforma esta disenada exclusivamente para su uso por personas mayores de dieciocho (18) anos de edad con capacidad legal para contratar.

**14.2.** El Responsable no recopila ni trata deliberadamente datos personales de menores de edad. Si el Responsable detecta que se han recopilado datos de un menor de edad, procedera a su eliminacion inmediata.

**14.3.** Si usted tiene conocimiento de que un menor de edad ha proporcionado datos personales a traves de la Plataforma, le solicitamos contactarnos de inmediato a [EMAIL_PROTECCION_DATOS].

---

## 15. CAMBIOS A LA POLITICA DE PRIVACIDAD

**15.1.** El Responsable se reserva el derecho de modificar la presente Politica en cualquier momento. Las modificaciones seran comunicadas a los Usuarios mediante:

   a) Publicacion de la version actualizada en la Plataforma;

   b) Notificacion por correo electronico a la direccion registrada, con al menos quince (15) dias de anticipacion a su entrada en vigencia;

   c) Aviso destacado en la Plataforma durante un periodo razonable.

**15.2.** Las modificaciones sustanciales que afecten significativamente los derechos del Usuario o la forma en que se tratan sus datos requeriran aceptacion expresa.

**15.3.** Las versiones anteriores de esta Politica estaran disponibles para consulta a solicitud del Usuario.

---

## 16. CONTACTO

**16.1.** Para cualquier consulta, solicitud o reclamacion relacionada con la presente Politica de Privacidad o con el tratamiento de sus datos personales, usted puede contactarnos a traves de:

   - **Correo electronico:** [EMAIL_PROTECCION_DATOS]
   - **Correo postal:** [NOMBRE DE LA EMPRESA], Atencion: Proteccion de Datos, [DIRECCION], [CIUDAD], Estado Plurinacional de Bolivia
   - **Telefono:** [TELEFONO_CONTACTO]
   - **Formulario web:** [URL_FORMULARIO_CONTACTO]

**16.2.** Nos comprometemos a atender todas las consultas y solicitudes en un plazo maximo de quince (15) dias habiles.

---

**[NOMBRE DE LA EMPRESA]**
**NIT: [NIT]**
**[DIRECCION], [CIUDAD]**
**Estado Plurinacional de Bolivia**

*Documento vigente desde [FECHA_VIGENCIA].*
*Version: 1.0*`;
